<div class="treemap-filters">
  <div class="newsfilter">
    <div
      class="filter saved pendo-filter-trigger"
      [class.active]="isFilterActive"
      aria-haspopup="menu"
      [attr.aria-expanded]="filterMenu.menuOpen"
      (click)="filterMenu.openMenu()"
    >
      <mat-icon>tune</mat-icon>
      <span class="filter-label">Filters</span>
    </div>
    <!--
      The panel is wider than the space to the left of the button, so anchoring the
      overlay to the button makes the CDK fall back to the opposite edge and open
      left. mat-menu right-aligns to its trigger, so the trigger is a zero-size
      anchor pinned under the nav bar at the window's right edge instead.
    -->
    <span
      class="filter-menu-anchor"
      #filterMenu="matMenuTrigger"
      [matMenuTriggerFor]="menuFilter"
      (onMenuClose)="resetFilterOptions()"
    ></span>
    <mat-menu #menuFilter="matMenu" xPosition="before">
      <div class="menuFilterClass" (click)="$event.stopPropagation()">
        <div class="list-container">
          <app-filter-presets-list
            [presets]="filterPresets"
            [control]="menuFilterPresets"
            [activeFilter]="userState.filter"
            [idCustomDefault]="idCustomDefault"
            [nameCustomDefault]="nameCustomDefault"
            (selectionChange)="handleSingleSelection($event, 'preset')"
            (save)="savePreset()"
            (deletePreset)="delPreset($event)"
            (setDefault)="setDefaultPreset($event)"
            (resetDefault)="resetDefaultPreset()"
          ></app-filter-presets-list>
        </div>

        <div class="list-container">
          <app-filter-simple-list
            header="Sentiment"
            listClass="listSentiments"
            optionClass="pendo-sentiment-option"
            [options]="filterSentiment"
            [control]="menuFilterSentiment"
            (selectionChange)="handleNoSelection()"
          ></app-filter-simple-list>
        </div>

        <div class="list-container" *ngIf="filterLang.length">
          <app-filter-simple-list
            header="Language"
            listClass="listLanguages"
            optionClass="pendo-language-option"
            [options]="filterLang"
            [control]="menuFilterLang"
            [showBetaBadge]="true"
            (selectionChange)="handleNoSelection()"
          ></app-filter-simple-list>
        </div>

        <div class="list-container">
          <app-filter-sources
            [geography]="filterGeography"
            [panels]="filterPanels"
            [geographyControl]="menuFilterGeography"
            [panelsControl]="menuFilterPanels"
            [geographyForm]="geographyForm"
            [geographyGroupOptions]="geographyGroupOptions"
            (search)="handleSearch($event.name, $event.type)"
            (toggleOption)="handleSelection($event)"
          ></app-filter-sources>
        </div>

        <div class="list-container">
          <app-filter-categories-list
            [categories]="filterCategories"
            [control]="menuFilterCategories"
            (toggleAll)="toggleAllCategories()"
            (toggleOption)="handleSelection($event)"
          ></app-filter-categories-list>
        </div>

        <div class="list-container">
          <app-filter-events-list
            [events]="filterEvents"
            [subEvents]="filterSubEvents"
            [control]="menuFilterEvents"
            (toggleAll)="toggleAllEvents()"
            (toggleOption)="handleSelection($event)"
          ></app-filter-events-list>
        </div>

        <div class="list-container">
          <app-filter-facttemp-list
            [factTemp]="filterFactTemp"
            [control]="menuFilterFactTemp"
            (toggleOption)="handleSelection($event)"
          ></app-filter-facttemp-list>
        </div>
      </div>

      <div class="menu-filters-footer">
        <button
          mat-button
          (click)="setFilterOptions()"
          class="pendo-apply-filter-button"
        >
          Apply Filter
        </button>
      </div>
    </mat-menu>
  </div>
</div>
